import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = [];

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert: (state, action) => {
      const { msg, type, timeout = 5000 } = action.payload;
      const id = uuidv4();
      state.push({ msg, type, id });
      
      // Auto-remove the alert after timeout
      setTimeout(() => store.dispatch(removeAlert(id)), timeout);
    },
    removeAlert: (state, action) => {
      return state.filter(alert => alert.id !== action.payload);
    }
  }
});

// Get a reference to the store after it's created
let store;
export const injectStore = _store => {
  store = _store;
};

export const { setAlert, removeAlert } = alertSlice.actions;

export default alertSlice.reducer; 